import * as React from 'react'

const EyeUnsee = (props: any) => {
  return (
    <svg
      {...props}
      className={'icon ' + props.className}
      width='16'
      height='11'
      viewBox='0 0 16 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.98567 0.982422C4.65811 0.982422 1.81638 3.04366 0.665039 5.95326C1.81638 8.86286 4.65811 10.9241 7.98567 10.9241C11.3132 10.9241 14.155 8.86286 15.3063 5.95326C14.155 3.04366 11.3132 0.982422 7.98567 0.982422ZM7.98567 9.26716C6.14886 9.26716 4.65811 7.78253 4.65811 5.95326C4.65811 4.12399 6.14886 2.63937 7.98567 2.63937C9.82249 2.63937 11.3132 4.12399 11.3132 5.95326C11.3132 7.78253 9.82249 9.26716 7.98567 9.26716ZM7.98567 3.96493C6.88092 3.96493 5.98914 4.85305 5.98914 5.95326C5.98914 7.05348 6.88092 7.9416 7.98567 7.9416C9.09043 7.9416 9.98221 7.05348 9.98221 5.95326C9.98221 4.85305 9.09043 3.96493 7.98567 3.96493Z'
        fill='#8C97A2'
      />
      <rect
        width='21.2527'
        height='1.32829'
        rx='0.664147'
        transform='matrix(0.70856 -0.70565 0.70856 0.70565 0 15.0625)'
        fill='#8C97A2'
      />
    </svg>
  )
}

export default EyeUnsee



// WEBPACK FOOTER //
// ./src/components/icons/ui/EyeUnsee.tsx